import { render } from "./SimpleCard.vue?vue&type=template&id=7a7ac1f7&ts=true"
import script from "./SimpleCard.vue?vue&type=script&lang=ts"
export * from "./SimpleCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__